"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
exports.isActive = isActive;
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var _filter2 = _interopRequireDefault(require("lodash/filter"));
var _classnames3 = _interopRequireDefault(require("classnames"));
var _item = _interopRequireDefault(require("./item.js"));
var _style = _interopRequireDefault(require("./style.css"));
var _excluded = ["item"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var _default = exports["default"] = (0, _reactRouterDom.withRouter)(function (props) {
  var nav = props.nav,
    render = props.render;
  var _useState = (0, _react.useState)(true),
    _useState2 = _slicedToArray(_useState, 2),
    collapsed = _useState2[0],
    changeCollapsed = _useState2[1];
  var navItems = nav.nav.map(function (defItem) {
    return constructItem(defItem, props.routes);
  });
  var NavItems = function NavItems() {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, navItems.map(function (item) {
      return /*#__PURE__*/_react["default"].createElement(_item["default"], _extends({
        key: item.handle,
        item: item,
        active: isActive(_objectSpread(_objectSpread({}, props), {}, {
          item: item
        }))
      }, props));
    }));
  };
  if (render) {
    return render(_objectSpread(_objectSpread({}, props), {}, {
      navItems: navItems,
      // components provided for convenience
      components: {
        NavItems: NavItems,
        Item: _item["default"]
      }
    }));
  }
  return /*#__PURE__*/_react["default"].createElement("nav", {
    className: (0, _classnames3["default"])('navbar', 'navbar-expand-xxl', _defineProperty({
      'navbar-light': !props.isInverse,
      'navbar-inverse': props.isInverse,
      'legos-navbar': !props.id
    }, "legos-navbar-".concat(props.id), props.id)),
    role: "navigation"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: props.className
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].expandButton
  }, /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    className: "navbar-toggler collapsed",
    onClick: function onClick() {
      return changeCollapsed(!collapsed);
    }
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "navbar-toggler-icon"
  }))), /*#__PURE__*/_react["default"].createElement("ul", {
    className: (0, _classnames3["default"])('nav', 'navbar-nav', 'navbar-collapse', 'me-auto', _style["default"].nav, _defineProperty({}, _style["default"].collapsed, collapsed))
  }, /*#__PURE__*/_react["default"].createElement(NavItems, null))));
});
function constructItem(defItem, routes) {
  var _filter$;
  defItem.url = (_filter$ = (0, _filter2["default"])(routes, function (r) {
    return r.handle === defItem.handle;
  })[0]) === null || _filter$ === void 0 ? void 0 : _filter$.url;
  defItem.render.params.activeRegex = new RegExp(defItem.render.params.activeRegex);
  if (defItem.render.type === 'dropdown') {
    var _defItem$render$param;
    defItem.render.params.children = ((_defItem$render$param = defItem.render.params.children) === null || _defItem$render$param === void 0 ? void 0 : _defItem$render$param.map(function (c) {
      return constructItem(c, routes);
    })) || [];
  }
  return defItem;
}
function isActive(_ref) {
  var item = _ref.item,
    props = _objectWithoutProperties(_ref, _excluded);
  return item.render.params.activeRegex.test(props.location.pathname) && props.routes.some(function (r) {
    return r.url === props.match.path;
  });
}